import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { useSearchPaymentCheckMutation } from '../../../services'
import { UspConfigurationPaymentCheckTypeViewResult } from '../../../models'
import Header from '../components/Header/Header'
import PaymentCheckTypesTable from './components/PaymentCheckTypesTable'
import AddEditPaymentCheckTypeModal from './components/AddEditPaymentCheckTypeModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsPaymentCheckTypes = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchPaymentCheck, { data, isLoading }] = useSearchPaymentCheckMutation()
  const [checkTypesData, setCheckTypesData] = useState<UspConfigurationPaymentCheckTypeViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchPaymentCheck({
      simpleSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCheckTypesData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Check Types'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <PaymentCheckTypesTable
                      loading={isLoading}
                      data={checkTypesData}
                      setData={setCheckTypesData}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditPaymentCheckTypeModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationPaymentCheckTypeViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsPaymentCheckTypes
